















import { Vue, Component } from "@/shared/vuepack";
import { Permission } from "@/shared/types";
import { PartnerHome, EmployerHome, PartnerEmployeeSearch,
  PartnerUsers } from "@/employer/route-names";
import _ from "lodash";
import { useUserStore } from "@/shared/store/user";
import { usePartnerUserStore } from "@/shared/store/partnerUser";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

interface Swingable {
  abbr: string;
  id: number;
  key: string;
  name: string;
  isPr: boolean;
  isSelected: boolean;
}

@Component
export default class Swinger extends Vue {

    rolePermissionsStore = useRolePermissionsStore();
    userStore = useUserStore();
    partnerUserStore = usePartnerUserStore();

    swingOptions: Swingable[] = [];

    mounted () {
        this.buildSwingOptions();
    }

    get swings () { return this.swingOptions.length > 1; }

    onSwingClick (swingOption: Swingable) {
      if (swingOption.isSelected) {
        return;
      }

      this.partnerUserStore.clearNotificationEmail();

      let location: any = {name: EmployerHome, params: { employerId: swingOption.id}};
      if (swingOption.isPr) {
        if (this.rolePermissionsStore.userHasPartnerPermission(Permission.PartnerEmployerRead, swingOption.id)) {
            location = {name: PartnerHome, params: { partnerId: swingOption.id}};
        } else if (this.rolePermissionsStore.userHasPartnerPermission(Permission.ManagePartnerUserRead, swingOption.id)) {
            location = {name: PartnerUsers, params: { partnerId: swingOption.id}};
        } else {
            location = {name: PartnerEmployeeSearch, params: { partnerId: swingOption.id}};
        }
      } else {
        this.userStore.clearPartnerId();
      }

      this.$emit("click");

      this.$router.push(location);
      for (const option of this.swingOptions) {
        option.isSelected = false;

        if (option.id === swingOption.id) {
          option.isSelected = true;
        }
      }
    }

    buildSwingOptions () {
        let ers = this.userStore.employers;
        if (!ers) {
            ers = [];
        }

        let prs = this.userStore.partnersWithUserRoles;
        if (!prs) {
            prs = [];
        }

        const results: Swingable[] = [];
        for (const er of ers) {
            results.push({
                abbr: "",
                id: er.employerId,
                key: "",
                name: er.employerName,
                isPr: false,
                isSelected: er.employerId === this.userStore.employerId && !this.userStore.partnerId
            });
        }

        for (const pr of prs) {
            results.push({
                abbr: "",
                id: pr.partnerId,
                key: "",
                name: pr.companyName,
                isPr: true,
                isSelected: pr.partnerId === this.userStore.partnerId
            });
        }

        results.sort((a, b) => a.name.localeCompare(b.name));

        for (const result of results) {
            let abbr = "";
            const pieces = result.name.split(/\W/);

            for (const piece of pieces) {
                if (!piece) {
                    continue;
                }

                if (abbr.length >= 2) {
                    break;
                }

                abbr += piece[0];
            }

            result.abbr = abbr.toLocaleUpperCase();
            result.key = `${result.isPr}-${result.id}-${result.name}`;
        }

        this.swingOptions = this.swingOptions = _.uniqBy(results, item => item.key);
    }
}
